const STORE_KEY = 'EXAM'

export const FETCH_EXAM = `${STORE_KEY}/FETCH_EXAM`
export const FETCH_EXAM_FULL_DATA = `${STORE_KEY}/FETCH_EXAM_FULL_DATA`
